/**
 * @param CREATED 결제금액만 세팅 된 경우
 * @param WAIT 가상계좌 생성 후 입금을 기다리는 상태
 * @param OVERDUE 가상계좌 입금 기한이 만료된 경우
 * @param COMPLETE 가상계좌 입금 완료
 * @param PARTIAL_CANCELED 가상계좌 부분취소
 * @param CANCEL 가상계좌 취소
 */
export const ORDERS_PAYMENT_STATUS = {
	CREATED: 'CREATED',
	WAIT: 'WAIT',
	OVERDUE: 'OVERDUE',
	COMPLETE: 'COMPLETE',
	PARTIAL_CANCELED: 'PARTIAL_CANCELED',
	CANCEL: 'CANCEL',
};

export default null;
